export default "__VITE_ASSET__yhJTpHOY__"